export const traceLog: Array<{
  event: string
  data: Record<string, unknown>
}> = []
